import axios from 'axios';
import {backendHost} from '../../config';

export const getMailingStatisticsScrollerUsersDepositsByUser = (params) => {
    return axios.get(`${backendHost}/api/admin/v2/mailing/scrollers/deposits/by-user`, {params});
};